export const FITBIT_REQUIRED_SCOPE =
  "activity heartrate profile sleep oxygen_saturation respiratory_rate";
